import { render, staticRenderFns } from "./ParentToChildrenToGrandson.vue?vue&type=template&id=749cfe9c"
import script from "./ParentToChildrenToGrandson.vue?vue&type=script&lang=js"
export * from "./ParentToChildrenToGrandson.vue?vue&type=script&lang=js"
import style0 from "./ParentToChildrenToGrandson.vue?vue&type=style&index=0&id=749cfe9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports